import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHero";
import FinalCta from "../components/FinalCta";
import { SERVICES, IMG } from "../lib/content";

export default function Services() {
  return (
    <main data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        title="A complete stone"
        italic="restoration studio."
        subtitle="Eight specialised disciplines, delivered with one obsessive standard of finish."
        image={IMG.blackStaircase}
      />

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 divide-y divide-black/10">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.slug}
              data-testid={`service-row-${s.slug}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.05 }}
              className="group grid grid-cols-1 lg:grid-cols-12 gap-8 bg-white py-10 md:py-14"
            >
              <div className="lg:col-span-1 flex items-start justify-start lg:justify-center">
                <span className="font-serif-italic text-[#B8965A] text-2xl">
                  0{i + 1}
                </span>
              </div>
              <div className="lg:col-span-4 img-zoom-wrap">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-[260px] md:h-[320px] object-cover"
                  loading="lazy"
                />
              </div>
              <div className="lg:col-span-7 flex flex-col justify-center">
                <div className="flex items-center gap-3 text-[#B8965A]">
                  <s.icon className="w-5 h-5" strokeWidth={1.4} />
                  <span className="text-[11px] uppercase tracking-[0.24em]">Service</span>
                </div>
                <h2 className="font-display-bold text-3xl md:text-4xl tracking-tight text-[#0A0A0A] mt-4">
                  {s.title}
                </h2>
                <p className="mt-5 text-[#525252] leading-relaxed text-[15px] md:text-base max-w-2xl">
                  {s.long}
                </p>
                <Link
                  to="/contact"
                  data-testid={`service-row-cta-${s.slug}`}
                  className="mt-7 self-start inline-flex items-center gap-2 px-6 py-3 border border-[#0A0A0A]/25 text-[#0A0A0A] text-[11px] uppercase tracking-[0.22em] hover:bg-[#0A0A0A] hover:text-white transition-colors"
                >
                  Request quote
                  <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </section>

      <FinalCta />
    </main>
  );
}
